import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {UI} from "../../../stem-core/src/ui/UIBase";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils";
import {RadioButton} from "../../../core/ui/input/radio/RadioButtonsInput.jsx";
import {BUTTON_TYPE} from "../../Constants.js";


class DonateActiveButtonListStyle extends StyleSheet {
    @styleRule
    container = {
        fontSize: this.themeProps.FONT_SIZE_LARGE,
    };

    @styleRule
    row = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        ":not(:last-child)": {
            marginBottom: 12
        }
    };

    @styleRule
    listItem = {
        flex: 1,
        ":not(:last-child)": {
            marginRight: 6,
        },
        ":not(:first-child)": {
            marginLeft: 6,
        },
        padding: 12
    };
}

@registerStyle(DonateActiveButtonListStyle)
export class DonateActiveButtonList extends UI.Element {
    activeButtonIndex = this.options.defaultActiveButtonIndex;
    buttonsRowCountMap = {
        "4": 2,
        "5": 3,
        "6": 3,
        "7": 4,
        "8": 4,
    };

    getDefaultOptions() {
        return {
            defaultActiveButtonIndex: 0,
            items: [],
            onSelect: NOOP_FUNCTION,
            rowSizeLimit: 3,
        }
    }

    setOptions(options) {
        if (options.defaultActiveButtonIndex !== this.options.defaultActiveButtonIndex) {
            this.activeButtonIndex = options.defaultActiveButtonIndex;
        }
        return super.setOptions(options);
    }

    getTotalButtonsCount() {
        return this.options.items.length;
    }

    getButtonElements() {
        return this.options.items.map((item, index) => (
            <RadioButton
                className={this.styleSheet.listItem}
                active={index === this.activeButtonIndex}
                type={index === this.activeButtonIndex ? BUTTON_TYPE.PRIMARY : BUTTON_TYPE.SECONDARY}
                label={item.label}
                onClick={() => this.handleButtonClick(index)}/>
        ));
    }

    render() {
        const {styleSheet} = this;
        const {rowSizeLimit} = this.options;
        const rowSize = Math.min(this.buttonsRowCountMap[this.getTotalButtonsCount()] ?? rowSizeLimit, rowSizeLimit);

        const buttonRows = this.splitButtonsIntoRows(this.getButtonElements(), rowSize);

        return buttonRows.map(row => <div className={styleSheet.row}>{row}</div>);
    }

    splitButtonsIntoRows(buttonComponents=[], inputRowSize= 1) {
        let rowSize = inputRowSize;
        const rows = [];
        let i = 0;

        while (i < buttonComponents.length) {
            rows.push(buttonComponents.slice(i, i + rowSize));
            i += rowSize;
            let remainingButtonsAfterNextStep = buttonComponents.length - i;
            if (remainingButtonsAfterNextStep < rowSize) {
                rowSize = remainingButtonsAfterNextStep;
            }
        }
        while (rows.length > 1 && rows[rows.length - 1].length !== inputRowSize) {
            rows[rows.length - 1].push(<div className={this.styleSheet.listItem}/>);
        }

        return rows;
    }

    handleButtonClick(buttonIndex) {
        const {onSelect, items} = this.options;
        this.updateActive(buttonIndex);
        onSelect(items[buttonIndex].value);
    }

    updateActive(index) {
        this.activeButtonIndex = index;
        this.redraw();
    }
}
